<template>
    <div class="message-wrepper">
        <div class="message slideInRight faster animated"
        v-for="(msg,index) in messages" :key="index"
        :class="msg.type"
        v-html="msg.msg"
        ></div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            messages:[],
            error:"#e74444",
            success:"#67c23a"
        }
    },
    methods:{
        reportMsg(msg,type,time = 4000){
            let id = Date.now()
            this.messages.push({msg:msg,type:type,id:id})
            this.removeMsg(id,time);
        },
        removeMsg(id,time){
            setTimeout(()=>{
                let index = this.messages.findIndex(m=> m.id == id);
                if(index != -1){
                    this.messages.splice(index,1);
                }
            },time);       
        }
    }
}
</script>

<style scoped>
.message-wrepper{
    position: fixed;
    bottom: 0%;
    right: 0%;
    z-index: 100000;
    padding: 15px;
}
.message{
    margin: 12px;
    border-radius: 13px;
    padding: 5px;
    color: #FFFFFF;  
}
.error{
    border: solid rgba(231, 68, 68, 1);
    background-color: rgba(231, 68, 68, 1);
}
.success{
    border: solid rgba(33,185,122,1);
    background-color: rgba(33,185,122,1);
}
</style>



// WEBPACK FOOTER //
// resources/js/components/partials/Messaging.vue